import '../Authorization.css';
import React, { useEffect, useState } from 'react';
import { useLanguage } from '../LanguageContext';
import { getTranslation } from '../consts/translations';

interface VerificationProps {
  setVerificationCode: (id: string) => void;
  onValidateCode: () => void;
  buttonDisabled: boolean;
  loading: boolean;
  verificationError: string;
  sendVerification: () => Promise<void>;
  inputPhoneOrEmail: string;
  onExit: () => void;
  sendAgainClicked: boolean;
  setSendAgainClicked: (sendAgainClicked: boolean) => void;
}

const Verification: React.FC<VerificationProps> = ({
  setVerificationCode,
  onValidateCode,
  buttonDisabled,
  loading,
  verificationError,
  sendVerification,
  inputPhoneOrEmail,
  sendAgainClicked,
  setSendAgainClicked,
}) => {
  const [timer, setTimer] = useState(30);
  const { language } = useLanguage();
  const translation = getTranslation(language);

  const handleSendAgainClick = () => {
    if (!sendAgainClicked) {
      setSendAgainClicked(true);
      setTimer(30);
      sendVerification();
    }
  };

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0 && sendAgainClicked) {
      setSendAgainClicked(false);
    }

    return () => clearInterval(interval);
  }, [sendAgainClicked, setSendAgainClicked, timer]);

  return (
    <div className='login-container'>
      {
        <>
          <div className='login-description'>
            {translation.verification_description} - {inputPhoneOrEmail}
          </div>
          <input
            className='login-input'
            style={{ width: '180px' }}
            placeholder={translation.enter_code_placeholder}
            onChange={(e) => setVerificationCode(e.target.value)}
          />
          {verificationError && <div className='login-verification-error'>{verificationError}</div>}
          <div
            className='send-again-text'
            style={verificationError ? { marginTop: '10px' } : { marginTop: '20px' }}
          >
            {sendAgainClicked ? (
              <div className='spinner-container'>
                <div className='spinner-wrapper'>
                  <div className='spinner'></div>
                  <div className='timer'>{timer}</div>
                </div>
                <span className='wait-text'>{translation.wait_for_code}</span>
              </div>
            ) : (
              <>
                <span>{translation.code_not_received}</span>
                <span className='send-again-button' onClick={handleSendAgainClick}>
                  {translation.send_code_again}
                </span>
              </>
            )}
          </div>
          <button
            className={`login-button ${loading ? 'loading' : ''}`}
            disabled={loading || !buttonDisabled}
            onClick={onValidateCode}
          >
            {loading ? '' : translation.to_status_page_text}
          </button>
        </>
      }
    </div>
  );
};

export default Verification;
